export const RawDocumentDataConfig = [
  {
    label: 'Event Id',
    key: 'eventID',
    type: 'text'
  },
  {
    label: 'Engagement Id',
    key: 'engagementID',
    type: 'text'
  },
  {
    label: 'Program Type',
    key: 'programType',
    type: 'text'
  },
  {
    label: 'Workshop Type',
    key: 'workshopType',
    type: 'text'
  },
  {
    label: 'Customer Status',
    key: 'customerStatusCounts',
    type: 'array'
  },
  {
    label: 'Target Product',
    key: 'eventTargetProductName',
    type: 'text'
  },
  {
    label: 'Qualified Amount',
    key: 'qualifiedAmount',
    type: 'text'
  },
  {
    label: 'Partner organization',
    key: 'partnerOrganization',
    type: 'text'
  },
  {
    label: 'Partner requestor email',
    key: 'partnerEmail',
    type: 'text'
  },
  {
    label: 'Registation Date',
    key: 'registrationDate',
    type: 'date'
  },
  {
    label: '90 Expiration Date',
    key: 'dayExpiration90',
    type: 'date'
  },
  {
    label: 'POE Expiration Date',
    key: 'dayExpiration60',
    type: 'date'
  },
  {
    label: 'Workshop Completion Date',
    key: 'workshopCompletionDate',
    type: 'date'
  },
  {
    label: 'Status',
    key: 'documentStatus',
    type: 'text'
  },
  {
    label: 'Upload Date',
    key: 'uploadDate',
    type: 'date'
  },
  {
    label: 'Customer',
    key: 'approvedCustomersList',
    type: 'array'
  }
];
export const MrppRawDocumentDataConfig = [
  {
    label: 'Engagement ID',
    key: 'eventID',
    type: 'text'
  },
  {
    label: 'Engagement Type',
    key: 'workshopType',
    type: 'text'
  },

  {
    label: 'Qualified Amount',
    key: 'qualifiedAmount',
    type: 'text'
  },
  {
    label: 'Customer Name',
    key: 'approvedCustomersList',
    type: 'array'
  },
  {
    label: 'Partner organization',
    key: 'partnerOrganization',
    type: 'text'
  },
  {
    label: 'Partner requestor email',
    key: 'partnerEmail',
    type: 'text'
  },
  {
    label: 'Committed Date',
    key: 'committedDate',
    type: 'date'
  },
  {
    label: 'Customer Ack Expiration Date',
    key: 'customerAckExpirationDate',
    type: 'date'
  },
  {
    label: 'POE Expiration Date',
    key: 'poeExpirationDate',
    type: 'date'
  },
  {
    label: 'Engagement Completion Date',
    key: 'workshopCompletionDate',
    type: 'date'
  },
  {
    label: 'Status',
    key: 'documentStatus',
    type: 'text'
  },
  {
    label: 'Upload Date',
    key: 'uploadDate',
    type: 'date'
  }
];
